import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RouterService } from './router.service';
import { Observable } from 'rxjs';
import { UserResource } from '../types/users';
import { CachedHttpService } from './cached-http.service';

@Injectable({ providedIn: 'root' })
export class ResourceService {
    private url = this.routerService.getApiUrl('user/resources', true);

    constructor(
        private http: HttpClient,
        private cachedHttp: CachedHttpService,
        private routerService: RouterService,
    ) {}

    getUserResources(invalidate: boolean = false): Observable<UserResource[]> {
        return this.cachedHttp.get<UserResource[]>(this.url, invalidate);
    }

    saveResource(resource: UserResource, action: string) {
        const saveUrl = `${this.url}/${action}`;
        return this.http.post<UserResource>(saveUrl, resource);
    }

    saveResources(resources: UserResource[]) {
        const saveUrl = `${this.url}/update`;
        return this.http.post<UserResource[]>(saveUrl, resources);
    }
}
